import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { CrunchImportDataResult } from 'sharedFeatures/sharedModels/crunchImportDataResult';
import { CrunchCheckTokenResult } from 'sharedFeatures/sharedModels/crunchCheckTokenResult';

declare let handleAngularHttpError: any;

@Injectable({
    providedIn: 'root',
})
export class CrunchService {

    constructor(private http: HttpClient) {
    }

    public CheckTokenExpired(): Promise<CrunchCheckTokenResult> {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json; charset=utf-8');

        return new Promise((resolve, reject) => {
            const response = this.http.post<string>(window.appPath + 'Crunch/CheckTokenExpired', { headers: headers });
            lastValueFrom(response)
                .then((res: string) => {
                    let data: CrunchCheckTokenResult = JSON.parse(res);
                    resolve(data);
                })
                .catch((error: HttpErrorResponse) => {
                    console.error('CheckTokenExpired error', error);

                    handleAngularHttpError(error);

                    //if we need to transmit the error to a component
                    //reject(error);
                });
        });
    }

    public GetImportData(planGuid: string): Promise<CrunchImportDataResult> {

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json; charset=utf-8');

        const params = {
            planGuid
        };

        // Wrap http response with the custom promise to handle error
        return new Promise((resolve, reject) => {
            const response = this.http.get<string>(window.appPath + 'Crunch/GetImportData', { headers: headers, params: params });
            lastValueFrom(response)
                .then((res: string) => {
                    let data: CrunchImportDataResult = JSON.parse(res);
                    resolve(data);
                })
                .catch((error: HttpErrorResponse) => {
                    console.error('GetImportData error', error);

                    handleAngularHttpError(error);

                    //if we need to transmit the error to a component
                    //reject(error);
                });
        });
    }
}
